import { FormSectionHandler } from '../entity.handler';
import { IdName, UserResponse, UserUpdateRequest } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { EntityUtils, CheckListField, IdNameArrayComboValueHandlers } from '../utils';
import { ICONS } from '../icons';

interface EditorValues {
    roles: IdName[];
}

export class UserRolesSectionHandler implements FormSectionHandler<UserResponse, EditorValues> {

    type = 'form';
    icon = ICONS.userrole;
    bulk = true;
    
    title = this.translate('TITLE'); 
    description = this.translate('DESC');

    constructor(
        public admin: AdminEditorService,
        public ownerId: string
    ) {
    }

    properties = ['roles'];

    translate(key: string, values?: Object): string {
        return this.admin.translate(`EDITORS.USER.ROLES.${key}`, values);
    }

    applyUpdate(entity: UserResponse, payload: UserUpdateRequest): Promise<UserResponse> {
        return this.admin.applyUpdate(api => api.accounts.updateUser(entity.id, payload));
    }

    mapEntityToEditor(entity: UserResponse): Promise<EditorValues> {
        return Promise.resolve(EntityUtils.mergeFields(this.properties, entity, {}));
    }

    mapEditorToEntity(entity: UserUpdateRequest, values: EditorValues): Promise<UserUpdateRequest> {
        return Promise.resolve(EntityUtils.mergeFields(this.properties, values, entity));
    }

    getFields(entity: UserResponse): Promise<FormBuilderField[]> {
        return this.admin.getCached(`listUserRoles/${this.ownerId}`, api => api.accounts.listUserRoles(this.ownerId)).then(roles => {

            const values = [
                { key: '00000000-0000-0000-0000-000000000000', value: 'Administrator' },
                ...roles.items.map(role => ({ key: role.id, value: role.name })).sort((a, b) => a.value.localeCompare(b.value)),
            ];

            return [
                CheckListField('roles', this.translate('FIELDS.ROLES'), true, values, IdNameArrayComboValueHandlers),
            ];
        }).then(fields => EntityUtils.prepareBulk(!entity, ['roles'], fields));
    }

}
